import React from 'react';
import { Button, Layout } from 'antd';
import styles from './ProductCard.module.scss';
import { ProductCardProps } from './types';
import { ArrowUpRightIcon } from '@/shared/constants/icon';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useLocale, useTranslations } from 'next-intl';
import { ImageCarousel } from '@/shared/ui/ImageCarousel/ImageCarousel';
import useRouter from '@/shared/hooks/useNProgress/useNProgress';

const { Content } = Layout;

export function ProductCard({ id, icon, side, url, img, tKey }: ProductCardProps) {
  const t = useTranslations(tKey);
  const locale = useLocale();
  const router = useRouter();

  return (
    <Content
      className={styles.root}
      style={{
        background: side === 'left' ? 'var(--color-primary)' : 'var(--color-cream)',
        direction: side === 'left' ? 'ltr' : 'rtl'
      }}
    >
      <section className={styles.root_container}>
        <section className={styles.root_head}>
          <ScrollReveal variant="fadeUp"  >
            <figure className={styles.root_head_icon}>
              {icon}
            </figure>
          </ScrollReveal>
          <ScrollReveal variant="fadeUp"  >
            <div className={styles.root_head_type}>
              {t("type")}
            </div>
          </ScrollReveal>
        </section>
        <div className={styles.root_container_line} />
        <ScrollReveal variant="fadeUp"  >
          <h2>{t("title")}</h2>
        </ScrollReveal>
        <ScrollReveal variant="fadeUp"  >
          <h3>{t("desc")}</h3>
        </ScrollReveal>
        <Button
          className={styles.root_container_button}
          href={`${'/' + locale + url}`}
          // onClick={() => router.push('/' + locale + url)}
        >
          {t('viewMore')}
          <ArrowUpRightIcon size={'1dvw'} />
        </Button>
      </section>
      <ScrollReveal variant="fadeUp"  >
        <ImageCarousel imgs={img} title={t("title")} side={side} />
      </ScrollReveal>
    </Content>
  );
}
